// extracted by mini-css-extract-plugin
export default {"sandwich":"Sandwich_sandwich__fG9a+","sandwichLink":"Sandwich_sandwichLink__WS+o5","sandwichLine":"Sandwich_sandwichLine__WmRlG","bgPulse":"Sandwich_bgPulse__++-+D"};